import { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../layout/breadcrumbs';
import { handleServerError } from '../../../helpers';

class ServerError extends Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    handleServerError(error);
  }

  render() {
    // @ts-ignore
    if (this.state.hasError) {
      return (
        <div id="page-content">
          <Breadcrumbs crumbs={[{ page: '500' }]}/>

          <div className="container">
            <section id="500">
              <div className="error-page">
                <div className="title">
                  <img alt=""
                       src="/assets/img/error-page-background.png" className="top"/>
                  <header>500</header>
                  <img alt=""
                       src="/assets/img/error-page-background.png" className="bottom"/>
                </div>
                <h2 className="no-border">Internal Server Error</h2>
                <Link to="#" onClick={() => {
                  //@ts-ignore
                  this.props.history.goBack()
                }} className="link-arrow back">Go Back</Link>
              </div>
            </section>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ServerError;